import { getURLParam, getSessionStorageItemJson } from '@vfde-fe/sails_core';
import { QUERY_PARAM_YOUNG, QUERY_PARAM_TARIFF, QUERY_PARAM_DEVICE, SESSION_KEY } from 'Constant';
import { StateProps } from 'Container/App/interface';
import { initialState } from '../container/App/reducer';
import { SalesChannel } from '../enum';
import getPageOptions, { getProductIds, getSubscriptionIds } from './additionalPageOptionsHelper';
import { isNotEmptyString, isValidId } from './validator';

const setStateFromPageOptions = (draftState: StateProps) => {
    const pageOptions = getPageOptions();

    draftState.selectedOption.subscriptionId = pageOptions?.selectedOption.tariffId;
    draftState.selectedOption.hardwareId = pageOptions?.selectedOption.hardwareId;

    return draftState;
};

const setStateFromSession = (draftState: StateProps) => {
    let sessionState: StateProps;

    try {
        sessionState = getSessionStorageItemJson(SESSION_KEY);
    } catch (error) {
        console.warn('Failed to load draftState from SessionStorage', error);

        return draftState;
    }

    return { ...draftState, ...sessionState };
};

const setStateFromQuery = (draftState: StateProps) => {
    const isYoung = getURLParam(QUERY_PARAM_YOUNG);
    const subscriptionId = getURLParam(QUERY_PARAM_TARIFF);
    const hardwareId = getURLParam(QUERY_PARAM_DEVICE);

    if (isNotEmptyString(isYoung)) {
        draftState.salesChannel = SalesChannel.YOUNG;
    } else if (draftState.salesChannel === SalesChannel.YOUNG) {
        draftState.salesChannel = SalesChannel.CONSUMER;
    }

    if (isValidId(hardwareId, getProductIds())) {
        draftState.selectedOption.hardwareId = hardwareId;
    }

    if (isValidId(subscriptionId, getSubscriptionIds())) {
        draftState.selectedOption.subscriptionId = subscriptionId;
    }

    return draftState;
};

const loadState = (): Partial<StateProps> => {
    let draftState: StateProps = JSON.parse(JSON.stringify(initialState));

    draftState = setStateFromSession(draftState);
    draftState = setStateFromPageOptions(draftState);
    draftState = setStateFromQuery(draftState);

    draftState.selectedOption.hardware = undefined;
    draftState.selectedOption.subscription = undefined;

    return draftState;
};

export default loadState;
